<template>
  <div>
    <el-row class="title-group">
      <el-col :span="4">
        <div class="fontSize20">
          <span>{{ timer }}秒</span>
          <span>{{ this.vx_lastUpdateTime }}</span>
        </div>
      </el-col>
      <el-col :span="4">
        <el-tooltip
          class="item"
          effect="dark"
          content="請勿連續點擊"
          placement="top-start"
        >
          <el-button
            :disabled="isReloadDisabled"
            type="primary"
            size="small"
            icon="el-icon-refresh-left"
            @click="refresh"
          >
            重新整理
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="5">
        <div class="fontSize20 title-red">
          預約司機提醒未回覆: {{ nonReplyTotal }}
        </div>
      </el-col>
      <el-col :span="4">
        <el-switch
          v-model="switchSpeech"
          active-text="開啟語音"
          inactive-text="關閉語音"
          @change="
            (status) => {
              this.switchSpeech = status
              this.vx_setSwitchSpeech(status)
            }
          "
        ></el-switch>
      </el-col>
    </el-row>
    <!--BUG: 在local開發95rem, 在stage須107rem-->
    <el-tabs type="border-card" v-model="currentTab" style="height: 107rem">
      <!--客服資訊tab-->
      <el-tab-pane name="bill">
        <span slot="label" style="font-size: 24px">客服資訊</span>
        <div
          class="row"
          style="display: flex; align-items: center; margin-bottom: 1rem"
        >
          <div class="col-md-1">
            <el-select v-model="billPagingNpp" @change="onChangeNpp">
              <el-option
                v-for="npp in [25, 50, 100]"
                :key="npp"
                :label="npp"
                :value="npp"
              ></el-option>
            </el-select>
          </div>
          <div class="col-md-6">
            <el-radio-group class="pick" v-model="picked" @input="onRadio">
              <el-tooltip placement="top">
                <div slot="content">顯示 1 小時內的 立即單、排班單、後派單</div>
                <el-radio :label="0">顯示全部</el-radio>
              </el-tooltip>
              <el-radio :label="1">已接到單的訂單</el-radio>
              <el-radio :label="2">目前未完成的訂單</el-radio>
            </el-radio-group>
          </div>
        </div>
        <BillList class="point" ref="getNewBill" @open-modal="openModal" />
      </el-tab-pane>
      <!--預約單tab-->
      <el-tab-pane name="reserve">
        <span slot="label" style="font-size: 24px">
          預約單 ({{ this.vx_reserveCount }})
        </span>
        <h4 v-show="currentTab === 'reserve'">
          顯示「目前時間」前後一小時的預約單
        </h4>
        <ReserveList />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { reqNonReply, reqOrderDetail } from '@/api/hailState-v2'
import { cookies } from '@/utils/cookies'
import { mapState, mapMutations, mapActions } from 'vuex'
import BillList from './BillList'
import ReserveList from './ReserveList'

export default {
  components: {
    BillList,
    ReserveList,
  },
  data() {
    return {
      currentTab: 'bill',
      // timer
      timer: 30,
      timerId: null,
      reqCount: 0,
      isReloadDisabled: false,
      // 客服資訊篩選條件
      picked: 0,
      task: 'all',
      billPagingNpp: 25,
      nonReplyTotal: 0,
      switchSpeech: true,
    }
  },
  computed: {
    ...mapState('hailStateV2', {
      vx_billList: 'billList',
      vx_reserveList: 'reserveList',
      vx_kw: 'kw',
      vx_lastUpdateTime: 'lastUpdateTime',
      vx_reservePaging: 'reservePaging',
      vx_reserveCount: 'reserveCount',
      vx_isModalOpen: 'isModalOpen',
    }),
  },
  watch: {
    currentTab: function () {
      if (this.currentTab === 'reserve') {
        this.vx_fetchReserveList()
      } else if (this.currentTab === 'bill') {
        this.vx_fetchBillList()
        this.vx_fetchReserveListCount()
      }
    },
  },
  methods: {
    ...mapMutations('hailStateV2', {
      vx_setBillList: 'setBillList',
      vx_setBillPagingNpp: 'setBillPagingNpp',
      vx_setBillPagingCurrentPage: 'setBillPagingCurrentPage',
      vx_setBillModal: 'setBillModal',
      /* vx_setModalState: 'setModalState', */
      vx_setPicked: 'setPicked',
      vx_setTask: 'setTask',
      vx_setKw: 'setKw',
      vx_setSwitchSpeech: 'setSwitchSpeech',
      vx_setRefreshClick: 'setRefreshClick',
    }),
    ...mapActions('hailStateV2', {
      vx_fetchBillList: 'fetchBillList',
      vx_refreshModalInfo: 'refreshModalInfo',
      vx_fetchReserveList: 'fetchReserveList',
      vx_fetchReserveListCount: 'fetchReserveListCount',
    }),
    async checkNonReply() {
      try {
        const { result } = await reqNonReply()
        this.nonReplyTotal = result.nonReplyTotal
      } catch (e) {
        console.error(e)
      }
    },
    onRadio(val) {
      /* (picked=0, task=all), (picked=1, task=received), (picked=2, task='') */
      if (val === 0) {
        this.task = 'all'
      } else if (val === 1) {
        this.task = 'received'
      } else {
        this.task = ''
      }
      this.picked = val
      this.vx_setPicked(val)
      this.vx_setTask(this.task)
      this.vx_setBillPagingCurrentPage(1)
      this.vx_fetchBillList()
      this.vx_fetchReserveListCount()
    },
    onChangeNpp(npp) {
      this.vx_setBillPagingCurrentPage(1)
      this.vx_setBillPagingNpp(npp)
      this.vx_fetchBillList()
    },
    /* timer */
    timerStart(startTime) {
      this.timer = startTime
      this.timerId = setInterval(() => {
        if (this.timer - 1 < 0) {
          this.reqCount += 1
          this.timer = startTime
          if (this.currentTab === 'reserve') {
            this.vx_fetchReserveList()
          } else if (this.currentTab === 'bill') {
            this.vx_fetchBillList()
            this.vx_fetchReserveListCount()
          }
          /* this.vx_fetchBillList()
          this.vx_fetchReserveListCount() */
          if (this.vx_isModalOpen) {
            this.vx_refreshModalInfo()
          }
          if (this.reqCount === 20) {
            this.reqCount = 0
            this.checkNonReply()
          }
        } else {
          this.timer -= 1
        }
      }, 1000)
    },
    timerStop() {
      clearInterval(this.timerId)
    },
    resumeTimer() {
      this.timerStart(this.timer)
    },
    refresh() {
      this.isReloadDisabled = true
      clearInterval(this.timerId)
      this.vx_setRefreshClick()
      if (this.currentTab === 'reserve') {
        this.vx_fetchReserveList()
      } else if (this.currentTab === 'bill') {
        this.vx_fetchBillList()
        this.vx_fetchReserveListCount()
      }
      /* this.vx_fetchBillList()
      this.vx_fetchReserveListCount() */
      this.timerStart(this.TIMER_START)
      this.handleReloadDisabled()
    },
    handleReloadDisabled() {
      setTimeout(() => {
        this.isReloadDisabled = false
      }, 10 * 1000)
    },
    async openModal(orderId) {
      try {
        const { result } = await reqOrderDetail(orderId)
        /* console.log('orderDetail res', result) */
        this.vx_setBillModal(result)
        this.$emit('open-modal')
      } catch (e) {
        console.error(e)
      }
    },
  },
  created() {
    this.TIMER_START = 30
  },
  mounted() {
    if (cookies.get('GladTeamCode') === '300') {
      this.switchSpeech = false
      this.vx_setSwitchSpeech(false)
    }
    this.timerStart(this.TIMER_START)
    this.checkNonReply()
  },
  beforeDestroy() {
    clearInterval(this.timerId)
  },
}
</script>

<style scoped>
.title-red {
  color: #ff3d51;
}

.title-group {
  margin-bottom: 1rem;
}

.el-button--primary.is-disabled {
  background-color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailState/components-v2/Main.vue